<app-top-bar></app-top-bar>


  <router-outlet></router-outlet>

<app-footer></app-footer>


<!-- 
Copyright Google LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at https://angular.io/license
-->